import React from 'react';
import { Button, Dropdown, Avatar } from 'antd';
import { MenuOutlined, UserOutlined, EditOutlined, LogoutOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useOnboard } from '../pages/Onboard/OnboardContext';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import './Navbar.css';

const Navbar = ({ onMenuClick }) => {
  const { logout, user, isLoading } = useAuth();
  const { refreshOnboard } = useOnboard();
  const navigate = useNavigate();

  // Don't render navbar while loading
  if (isLoading) {
    return null;
  }

  const branchAcronym = user?.assignedBranch?.sigla ?? user?.assignedBranch?.acronym ?? '';
  const branchCode = user?.assignedBranch?.codigo ?? user?.empresa ?? '';
  const employeeCode = user?.codigo ?? user?.code ?? 'N/A';
  const employeeName = user?.name ?? user?.nome ?? 'Usuário';

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const handleEditProfile = () => {
    navigate('/profile');
  };

  const handleMainMenu = () => {
    navigate('/modules');
  };

  const handleRefresh = async () => {
    try {
      try { window.dispatchEvent(new CustomEvent('onboard-refresh')); } catch { }
      await refreshOnboard();
    } catch { }
  };

  const userMenuItems = [
    {
      key: 'main-menu',
      label: 'Menu principal',
      icon: <MenuOutlined />,
      onClick: handleMainMenu
    },
    {
      key: 'edit-profile',
      label: 'Editar Perfil',
      icon: <EditOutlined />,
      onClick: handleEditProfile
    },
    {
      key: 'reload-page',
      label: 'Atualizar Página',
      icon: <ReloadOutlined />,
      onClick: handleRefresh
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: handleLogout,
      danger: true
    }
  ];
  return (
    <nav className="navbar-container">
      {/* Seção da Filial - Laranja */}
      <div className="navbar-section branch-section">
        <div className="branch-acronym">{branchAcronym}</div>
        <div className="branch-code">{branchCode}</div>
      </div>

      {/* Seção do Funcionário  */}
      <div className="navbar-section employee-section">
        <div className="employee-code">{employeeCode}</div>
        <div className="employee-name">{employeeName}</div>
      </div>

      {/* Controles - Tema, User Menu e Menu */}
      <div className="navbar-controls">
        <ThemeToggle size="large" type="text" className="theme-toggle" />

        {/* Mobile Menu Button */}
        {onMenuClick && (
          <Button
            type="text"
            className="mobile-menu-button"
            size="large"
            icon={<MenuOutlined />}
            onClick={onMenuClick}
            style={{
              border: 'none',
              background: 'transparent',
              color: 'var(--navbar-text-color)'
            }}
          />
        )}

        {/* User Menu Dropdown */}
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button
            type="text"
            className="user-menu-button"
            size="large"
            style={{
              border: 'none',
              background: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: 'var(--navbar-text-color)'
            }}
          >
            <Avatar
              size="small"
              icon={<UserOutlined />}
              style={{
                backgroundColor: 'var(--navbar-control-avatar-bg)',
                color: 'var(--navbar-text-color)'
              }}
            />
          </Button>
        </Dropdown>

      </div>


    </nav>
  );
};

export default Navbar;